export const removeQuizProgress = (config) => {
    const { annotations } = config;
    const annotationsWithoutQuizProgress = annotations.filter((annotation) => {
        return annotation.type !== 'progress';
    });

    return {
        ...config,
        annotations: annotationsWithoutQuizProgress
    };
};